import React from 'react';
import AviveEventStatus from './AviveEventStatus';
import AviveStandaloneStatus from './AviveStandaloneStatus';
import { AED_STATUS_MODE } from './aviveStatusTypes';

const renderAviveStatus = (
  statusInfo,
  onCancel = () => {},
  onNewNote = () => {},
  rest = {},
) => {
  const message = statusInfo?.message;
  const mode = statusInfo?.mode;

  switch (mode) {
    case AED_STATUS_MODE.EVENT: {
      return (
        <AviveEventStatus
          status={message}
          onNewNote={onNewNote}
          onCancel={onCancel}
          {...rest}
        />
      );
    }
    case AED_STATUS_MODE.NONE: {
      return null;
    }
    case AED_STATUS_MODE.STANDALONE:
    default:
      return (
        <AviveStandaloneStatus status={message} onCancel={onCancel} {...rest} />
      );
  }
};

const AviveStatus = ({
  status,
  onCancel = () => {},
  onNewNote = () => {},
  ...rest
}) => {
  if (!status || Object.keys(status).length === 0) {
    return null;
  }
  return renderAviveStatus(status, onCancel, onNewNote, rest);
};

export default AviveStatus;
